// Candle Anatomy — the Candle-Anatomy-specific part of the Read: its candles,
// its six prompts and their copy. Everything else (tap surface, feedback
// states, grading, the lesson flow) is shared Edge code.
//
// Copy is the locked storyboard wording (TAP VARIANT). Where the storyboard's
// Beat 1 instructions contain an em dash — which the same storyboard bans from
// user-facing copy — the instruction is split into a title and a subline
// instead ("Tap where Open is" / "Where price started"), keeping the words.

// PLACEHOLDER OHLC. QUSHi supplies the final values; these only reproduce the
// shapes the storyboard asks for, so the flow can be reviewed.
export const CANDLES = {
  // Beat 1: green, short wicks, clean body.
  teach: { open: 103.2, high: 105.45, low: 102.85, close: 105.1 },
  // Beat 2: red, long lower wick, short upper wick.
  callIt: { open: 105.2, high: 105.6, low: 102.4, close: 103.9 },
  // Retry candles, in order: every retry is a fresh candle the learner has not
  // seen. Only the first READ.maxRetries are used. Keep at least that many.
  // First: green, long upper wick, no lower wick (open equals low).
  retries: [
    { open: 102.9, high: 105.8, low: 102.9, close: 104.1 },
    // Red, no upper wick (open equals high), long lower wick.
    { open: 105.0, high: 105.0, low: 102.6, close: 103.7 },
    // Green, both wicks.
    { open: 103.4, high: 105.7, low: 102.7, close: 104.8 },
  ],
  // Beat 3 non-interactive diagrams.
  noUpperWick: { open: 103.4, high: 105.0, low: 102.8, close: 105.0 },
  noLowerWick: { open: 103.0, high: 105.2, low: 103.0, close: 104.6 },
};

// Per-Read behaviour settings (client: "Retry count = a configurable value per
// Read, not hardcoded"). Candle Anatomy: 2 retries after the first attempt, 3
// attempts in all; after the last one the Read auto-completes (no first-attempt
// bonus), so no one is trapped.
//
// hint: switched off for launch, kept for harder Reads ("leave it off, but
// don't throw away the work"). When enabled, "Need a hint?" appears in Call It
// after delayMs without a tap, and opening it forfeits the first-attempt bonus.
export const READ = {
  maxRetries: 2,
  hint: { enabled: false, delayMs: 20000 },
};

// PLACEHOLDER reward values (QUSHi supplies them before QA). Display only in
// Phase 1: nothing is credited to the wallet.
export const REWARDS = { completion: 50, firstAttemptBonus: 25 };

export const PROMPTS = [
  {
    id: "open",
    label: "Open",
    title: "Tap where Open is",
    sub: "Where price started",
    teach: "Open is where price started. On a green candle, that is the bottom of the body.",
  },
  {
    id: "close",
    label: "Close",
    title: "Tap where Close is",
    sub: "Where price ended",
    teach: "Close is where price ended. On a green candle, that is the top of the body.",
  },
  {
    id: "high",
    label: "High",
    title: "Tap where High is",
    sub: "The highest price reached",
    teach: "High is the highest price reached.",
  },
  {
    id: "low",
    label: "Low",
    title: "Tap where Low is",
    sub: "The lowest price reached",
    teach: "Low is the lowest price reached.",
  },
  { id: "body", label: "Body", title: "Tap the body", sub: null, teach: "The body is the distance between open and close." },
  {
    id: "wick",
    label: "Wick",
    title: "Tap a wick",
    sub: null,
    teach: "Wicks are the thin lines beyond the body. They reach to the high and the low.",
  },
];

export const COPY = {
  submitGate: "Tap all 6 elements to continue",
  hint: "Green candle: the close is above the open. Red candle: the close is below the open.",
  noWick: "No upper wick means the high sits at the top edge of the body. No lower wick means the low sits at the bottom edge.",
  explain: {
    openCloseRed: "A candle is red because the close is below the open. Open and close are price points, not fixed positions.",
    openCloseGreen:
      "A candle is green because the close is above the open. Open and close are price points, not fixed positions.",
    highLow: "High and low are the furthest prices reached. When a wick is present, its tip marks that extreme.",
    body: "The body spans the distance between the open and close.",
    wick: "A wick is the thin line extending beyond the body. It reaches to the high or the low.",
    allCorrect: "Clean read. You correctly located the open, close, high, low, body, and wick on a candle you had not seen.",
  },
};
